import type { ShallowReactive } from 'vue';

import 'animate.css';

export interface Modal {
  id: symbol;
  component: Component;
  props?: any;
  hide: () => void;
}

export const modalStateKey: InjectionKey<ShallowReactive<Modal[]>> = Symbol('modalStateKey');

export default defineNuxtPlugin((nuxtApp) => {
  const modalState = shallowReactive<Modal[]>([]);
  nuxtApp.vueApp.provide(modalStateKey, modalState);
});
